import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'whatsappPhone',
})
export class WhatsappPhonePipe implements PipeTransform {
  transform(phone: string | null | undefined): string {
    if (!phone) return '';

    let digits = phone.replace(/\D/g, '');

    if (digits.startsWith('55')) {
      digits = digits.substring(2);
    }

    if (digits.length < 10) return phone;

    const ddd = digits.substring(0, 2);
    const number = digits.substring(2);

    const formatted =
      number.length === 9
        ? `(${ddd}) ${number.substring(0, 5)}-${number.substring(5)}`
        : `(${ddd}) ${number.substring(0, 4)}-${number.substring(4)}`;

    return formatted;
  }
}
